import './legal.scss';
import React from 'react';
import {Link, Navigate} from 'react-router-dom';
import Header from '../../../organisms/header/header.js';
import decodeToken from '../../../../utils/decode-token';
import Wadsworth from '../../../organisms/role-hac/wadsworth/wadsworth';
import { useTranslation } from 'react-i18next';
import SafeHtml from '../../../atoms/safe-html';
import Footer from "../../../organisms/footer/footer";

const HacLegalPrint = () => {

  const { t } = useTranslation();

  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;

  const loggedUser = JSON.parse(sessionStorage.getItem('loggedUser'));

  return (
    <>
      {token ? (
        <div className="App">
          <Header />
          <main className="legal">
            {token && role === 'hac' ? (
              <Wadsworth />
            ) : null}
            <section className="legal">
              <div className="inner">
                <Link to="/hac/main" className="back-button">
                  <span className="icon-chevron-left"></span>{' '}
                  {t('common-back')}
                </Link>
                {loggedUser && (loggedUser.preferredLanguage === 'en' || loggedUser.preferred_language === 'en') ? (
                  <>
                    <h2>{t(`legal-print-title-${loggedUser.preferredLanguage || loggedUser.preferred_language}-${loggedUser.area_code}`)}</h2>
                    <SafeHtml as="p" html={t(`legal-print-text-${loggedUser.preferredLanguage || loggedUser.preferred_language}-${loggedUser.area_code}`)} />
                  </>
                ) : (
                  <>
                    <h2>{t('legal-print-title')}</h2>
                    <SafeHtml as="p" html={t('legal-print-text')} />
                  </>
                )}

              </div>
            </section>
          </main>
          <Footer/>
        </div>
      ) : (
        <Navigate to="/login" />
      )}

    </>
  );
};

export default HacLegalPrint;
